import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const manageAppsAdapters: { [property: string]: EntityAdapter<any> } = {
    organizations: createEntityAdapter<ManageAppsOrganizationEntity>(),
};

export const manageAppsState: ManageAppsState = {
    organizationsMap: {},
    subscriptionPagination: {
        pageSize: undefined,
        pageIndex: undefined,
    },
    selectedBridgeId: undefined,
    bridgeIdsVsMetadataIds: {},
    assetType: undefined,
    subscriptionStatus: 'ALL',
    currentOrganizationId: undefined,
    pageSize: 20,
    pageIndex: 0,
    subscriptionsCount: {},
    searchText: undefined,
    currentBridgeId: undefined,
    organizations: manageAppsAdapters.organizations.getInitialState(),
    selectedServiceIds: [],
    selectedBundleId: undefined,
    selectedPackageId: undefined,
    assignableSubscriptionIds: {},
    bundleSubscribedAppIds: {},
    serviceIdsArray: [],
    organizationIdsArray: [],
    itemIdArray: [],
    orgIdArray: [],
    itemNames: [],
    getAppsByPagination: false,
    count: {},
    isGlobalRepository: false,
};

export interface ManageAppsState {
    organizationsMap: {
        // organizationId vs details
        [property: string]: {
            nonSubscribedApps: Service[];
            appsByStatus: {
                // appstatus vs apps
                [property: string]: Service[];
            };
            subscriptionApprovalApps: {
                // appstatus vs apps
                [property: string]: Service[];
            };
            allApps: Service[];
        };
    };
    subscriptionsCount: {
        // app status vs count
        [property: string]: number;
    };
    subscriptionPagination: {
        pageSize: number;
        pageIndex: number;
    };
    selectedServiceIds: string[];
    assetType: 'ASSET' | 'WIDGET' | 'BRIDGE_ASSET' | 'RECON' | 'DASHBOARD' | 'CONNECTOR';
    subscriptionStatus: 'ALL' | Service['status'];
    currentOrganizationId: string;
    pageSize: number;
    pageIndex: number;
    searchText: string;
    currentBridgeId: string;
    organizations: EntityState<ManageAppsOrganizationEntity>;
    selectedBundleId: string;
    selectedPackageId: string;
    assignableSubscriptionIds: {
        [property: string]: string[];
    };
    bundleSubscribedAppIds: {
        [property: string]: string[];
    };
    serviceIdsArray: string[];
    organizationIdsArray: string[];
    selectedBridgeId: string;
    bridgeIdsVsMetadataIds: {
        [property: string]: string;
    };
    orgIdArray: string[];
    itemIdArray: string[];
    itemNames: string[];
    getAppsByPagination: boolean;
    count: {
        [property: string]: number;
    };
    isGlobalRepository: boolean;
}

export interface ManageAppsOrganizationEntity {
    id: string;
    orgIdVsName?: { [property: string]: string };
    services: EntityState<Service>;
}

export interface Service {
    assetType: 'ASSET' | 'WIDGET' | 'BRIDGE_ASSET' | 'RECON' | 'DASHBOARD' | 'CONNECTOR';
    userName: string;
    subscriptionId: string;
    active: false;
    createdByUserId: string;
    createdDate: string;
    displayName: string;
    id: string;
    itemId: string;
    indexed: true;
    serviceName: string;
    lastModifiedByUserId: string;
    lastModifiedDate: string;
    organizationId: string;
    serviceId: string;
    status: 'APPROVED' | 'PENDING' | 'PENDING_DEACTIVATE';
    description: string;
    itemName: string;
    providerId: string;
    restApiName: string;
    type: string;
    helpDocuments: { [property: string]: string }[];
    selected?: boolean;
    suspended?: boolean;
    assetMetaUId?: string;
    bridgeNodes: {
        [property: string]: {
            componentType: 'ASSET' | 'FILE';
            subscriptionId: string;
            displayName: string;
            serviceName: string;
            id: string;
            level: number;
            name: string;
            nextNodes: string[];
            restApiName: string;
            version: string;
            helpDocuments: { [property: string]: string }[];
        };
    };
}
